/*
 * @Description:
 * @Author: 诺
 * @Date: 2022-04-18 14:59:58
 * @LastEditors: 诺
 * @LastEditTime: 2022-04-18 15:46:47
 */
export default {
  name: "lightup",
  imgDir: "lightup",
  pageData: {
    projectId: "61",
    projectName: "佘山项目",
    actName: "点亮活动模板",
    startTime: 1650211200000,
    endTime: 1650427200000,
    gpsSwitch: 1,
    couponSwitch: 0,
    rankPrizeSwitch: 0,
    watchShowSwitch: 1,
    joinShowSwitch: 1,
    rotationWinSwitch: null,
    status: 1,
    receiveAddress: '["武汉"]',
    lotteryTimesLimitSwitch: null,
    lotteryTimesDailyLimit: null,
    lotteryTimesDailyLimitSwitch: null,
    salesSiteShowSwitch: 1,
    winTimesLimit: 3,
    buttonBackgroundColour: "#28D4FE",
    shareInfo: "这个活动真有趣，快来参加看看吧！",
    popupStyleImg: "https://assets.rurushishi.com/activies/activityCenter/lightup/prizeImg.png",
    popupBackgroundColour: "#FFFFFF",
    bg2: "https://assets.rurushishi.com/activies/activityCenter/lightup/bg2.jpg",
    shareImg: "https://assets.rurushishi.com/activies/activityCenter/lightup/poster.jpg",
    buttonTextColour: "#FFFFFF",
    shareSwitch: 1,
    backgroundImg: "https://assets.rurushishi.com/activies/activityCenter/lightup/bg.jpg",
    topLogoImg: "https://assets.rurushishi.com/activies/activityCenter/turntableLottery/logo.png",
    actRule:
      "<p>1.玩家点击【我要点亮】按钮即可参与活动，找不同的好友帮忙来获得每个地标对应所需的点亮值。成功获得指定点亮值后即可点亮地标。首个地标进入游戏后自动点亮。</p><p>2.每点亮一个地标，都有机会获得随机金喜奖励和幸运抽奖机会；</p><p>3.玩家抽中实物奖品后，需正确填写领奖信息和短信验证码。填写成功后，奖品兑换码可以通过收到的中奖短信和活动页中【我的奖品】内进行查看；玩家可凭奖品兑换码，在指定时间内前往领奖地址进行核销领取。</p><p>4.玩家获得随机金喜红包后，请正确填写信息验证。奖励将会发放给玩家的微信账户中。（根据微信规定，需要玩家的微信账号提前完成实名制，方可成功发放）。</p><p>5.本次活动点亮值排名前X的玩家还可获得点亮排行特别奖励；排行榜前X的奖品将于活动结束后由客服统一通知领取。</p><p>6.点亮值需通过邀请不同好友助力获得，若发现玩家作弊或使用非正常手段获取。主办方有权取消其获奖资格。</p><p>7.玩家还可通过集结好友帮忙的方式，邀请新玩家一起来参与活动。每成功找到一位新玩家还能获得集结金喜奖励。帮忙的好友越多，获得的奖励越多哦！</p>",
    backgroundColour: "#5331DF",
    disclaimer: "本次活动最终解释权归开发商所有。",
    salesSiteTitle: "· 销售现场 ·",
    helpText: "点亮值",
    kv2: "https://assets.rurushishi.com/activies/activityCenter/lightup/kv.png",
    rotationWinSwitch: 1,
    shareButtonStyleImg: "",
    shareSmallImg: "https://assets.rurushishi.com/activies/activityCenter/lightup/shareIcon.jpg",
    mainKvImg: "https://assets.rurushishi.com/activies/activityCenter/lightup/kv.png",
    rankPrizeTitle: "· 排行奖品 ·",
    backgroundMusicSwitch: 0,
    shareTitle: "点亮0418",
    helpType: 1,
    mainColour: "#4870FF",
    backgroundMusicUrl: "http://assets.rurushishi.com/activies/rchd-blind-box-2021-11/bgm.mp3",
    couponTitle: "· 优惠券 ·",
    prizeTitle: "· 奖品展示 ·",
  },
};
